/* eslint-disable max-len */
const React = require('react')
const PropTypes = require('prop-types')
const withStyles = require('withStyles').default
const SignupButtons = require('./signup_buttons')
const styles = require('./headline.less')
const log = require('log').create('home', 'headline') // eslint-disable-line

function Header({ variant }) {
    switch (variant) {
        case 'from_profile':
            return (
                <h1>Make a name for yourself<br />with a page and a domain.</h1>
            )
        default:
            return (
                <h1>
                    Freelancers and entrepreneurs use about.me <span className="text nowrap">to grow their audience</span> <span className="text nowrap">and get more clients.</span>
                </h1>
            )
    }
}
Header.propTypes = {
    variant: PropTypes.string,
}


function Headline(props) {
    return (
        <div className={styles.scope}>
            <div className="header-wrapper">
                <div className="header-content">
                    <Header variant={props.variant} />
                    <SignupButtons
                        button_rank="secondary"
                        button_luminance="light"
                        enable_facebook={props.enable_facebook}
                        enable_google={props.enable_google}
                        variant={props.variant}
                        />
                </div>
            </div>
        </div>
    )
}

Headline.propTypes = {
    enable_facebook: PropTypes.bool,
    enable_google: PropTypes.bool,
    variant: PropTypes.string,
}

module.exports = withStyles(styles)(Headline)
